import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { z } from 'zod';
import { reset } from './sharedActions';

type Status = z.infer<typeof statusStateSchema>;
export const statusStateSchema = z.enum(['valid', 'expired']).default('valid');
export const statusSlice = createSlice({
  name: 'status',
  initialState: 'valid' as Status,
  reducers: {
    setStatus: (_, action: PayloadAction<Status>) => action.payload,
  },
  extraReducers: (builder) => {
    builder.addCase(reset, () => 'valid');
  },
});
